<div class="equipment-detail-container px-4 py-4">

    <!-- Premium Header with Glassmorphism -->
    <div class="glass-header flex flex-column md:flex-row align-items-center gap-3 mb-4" id="tour-eq-detail-header">
        <p-button icon="pi pi-arrow-left" [text]="true" severity="secondary" (onClick)="goBack()" [rounded]="true" styleClass="p-button-lg" pTooltip="Volver"></p-button>

        <div class="equipment-visual">
            <i class="pi pi-desktop"></i>
        </div>

        <div class="flex-grow-1 text-center md:text-left">
            <div class="flex align-items-center gap-3 mb-1 justify-content-center md:justify-content-start">
                <div class="flex align-items-center mb-3">
                    <i
                        class="pi pi-desktop text-4xl text-primary mr-3 shadow-2 p-2 border-round-circle bg-primary-reverse border-1 surface-border"></i>
                    <div>
                        <div class="flex align-items-center gap-2 flex-wrap">
                            <h1 class="text-3xl font-bold m-0 p-0 text-900 line-height-1">
                                {{ equipment()?.name || equipment()?.model || 'Detalle del Equipo' }}
                            </h1>
                            <span *ngIf="equipment()?.equipment_code"
                                class="px-3 py-1 bg-indigo-100 text-indigo-700 border-round-xl text-sm font-bold border-1 border-indigo-300 flex align-items-center gap-1">
                                <i class="pi pi-tag text-xs"></i>
                                {{ equipment()?.equipment_code }}
                            </span>
                        </div>
                        <div class="flex align-items-center mt-1 gap-2">
                            <span class="text-600 font-medium">{{ equipment()?.model || 'Visualización completa y
                                trazabilidad técnica' }}</span>
                            <span *ngIf="equipment()?.serial_number" class="text-500 text-sm">S/N: {{
                                equipment()?.serial_number }}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="flex flex-wrap align-items-center gap-4 justify-content-center md:justify-content-start mt-2">
                <div class="status-pill" [ngClass]="getStatusClass(equipment()?.status)">
                    <span class="status-dot"></span>
                    {{ translateStatus(equipment()?.status) }}
                </div>
                <!-- Horizontal ID Information -->
                <div
                    class="flex align-items-center gap-4 text-600 font-medium bg-white-alpha-50 px-3 py-2 border-round-xl">
                    <span class="flex align-items-center gap-1"><i class="pi pi-bookmark text-primary"></i> {{
                        equipment()?.brand?.name }}</span>
                    <span class="flex align-items-center gap-1"><i class="pi pi-barcode text-primary"></i> {{
                        equipment()?.serial_number || 'N/A' }}</span>
                    <span class="flex align-items-center gap-1"><i class="pi pi-map-marker text-primary"></i> {{
                        equipment()?.location?.name || 'No asignada' }}</span>
                </div>
            </div>
        </div>

        <div class="flex gap-2">
            <p-button label="Cambiar Estado" icon="pi pi-sync" severity="warn" (onClick)="openStatusModal()"
                styleClass="p-button-raised border-round-xl p-button-warning"></p-button>
            <p-button label="Editar" icon="pi pi-pencil" (onClick)="openEdit()"
                styleClass="p-button-outlined p-button-raised border-round-xl"></p-button>
            <p-button id="tour-eq-detail-report" label="Reporte" icon="pi pi-file-pdf" severity="help" (onClick)="downloadReport()"
                styleClass="p-button-raised border-round-xl"></p-button>
            <p-button icon="pi pi-question-circle" label="Ayuda" (onClick)="startDetailTour(true)" severity="info" [text]="true" id="tour-eq-detail-help"></p-button>
        </div>
    </div>

    <!-- Quick Stats Bar -->
    <div class="grid mb-4 px-2" id="tour-eq-detail-stats">
        <div class="col-12 sm:col-6 md:col-3">
            <div class="stat-mini-card">
                <span class="stat-label">Proveedor Principal</span>
                <span class="stat-value text-700"><i class="pi pi-building mr-1"></i>{{ equipment()?.vendor?.name || 'No
                    definido' }}</span>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
            <div class="stat-mini-card">
                <span class="stat-label">Próximo Mantenimiento</span>
                <span class="stat-value" [ngClass]="{'text-orange-500': equipment()?.next_maintenance_date}">
                    <i class="pi pi-calendar mr-1"></i>{{ (equipment()?.next_maintenance_date | date:'dd/MM/yyyy') ||
                    'Sin fecha' }}
                </span>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
            <div class="stat-mini-card">
                <span class="stat-label">Próxima Calibración</span>
                <span class="stat-value" [ngClass]="{'text-red-500': equipment()?.next_calibration_date}">
                    <i class="pi pi-check-circle mr-1"></i>{{ (equipment()?.next_calibration_date | date:'dd/MM/yyyy')
                    || 'Sin fecha' }}
                </span>
            </div>
        </div>
        <div class="col-12 sm:col-6 md:col-3">
            <div class="stat-mini-card">
                <span class="stat-label">Garantía</span>
                <span class="stat-value text-success">
                    <i class="pi pi-shield mr-1"></i>{{ (equipment()?.warranty_expiration | date:'dd/MM/yyyy') || 'Sin
                    garantía' }}
                </span>
            </div>
        </div>
    </div>

    <!-- Main Dashboard Grid -->
    <div class="grid" *ngIf="!loading(); else skeleton">

        <!-- Activity Logs - Full Width -->
        <div class="col-12">
            <div class="premium-card h-full overflow-hidden">
                <p-tabs id="tour-eq-detail-tabs" [value]="activeMainTabIndex()" (valueChange)="activeMainTabIndex.set($event)" [scrollable]="true">
                    <p-tablist>
                        <p-tab [value]="0"><i class="pi pi-th-large mr-2"></i>Resumen</p-tab>
                        <p-tab [value]="1"><i class="pi pi-wrench mr-2"></i>Mantenimientos</p-tab>
                        <p-tab [value]="2"><i class="pi pi-check-circle mr-2"></i>Calibraciones</p-tab>
                        <p-tab [value]="3"><i class="pi pi-history mr-2"></i>Bitácora</p-tab>
                        <p-tab [value]="4"><i class="pi pi-list-check mr-2"></i>Historial de Estado</p-tab>
                        <p-tab [value]="5"><i class="pi pi-folder-open mr-2"></i>Documentación</p-tab>
                        <p-tab [value]="6"><i class="pi pi-chart-line mr-2"></i>Predicciones y Salud</p-tab>
                    </p-tablist>
                    <p-tabpanels>
                        <!-- TAB 0: RESUMEN (NEW) -->
                        <p-tabpanel [value]="0">
                        <div class="grid mt-2 dashboard-grid">
                            <!-- Maintenance Card -->
                            <div class="col-12 md:col-4">
                                <div class="summary-card shadow-1 border-round-xl p-3 h-full flex flex-column justify-content-between" 
                                     [ngClass]="{'bg-blue-50': maintenanceStatus() === 'Al día', 'bg-red-50': maintenanceStatus() === 'Vencido' || maintenanceStatus() === 'Crítico'}">
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <div class="flex align-items-center gap-2">
                                            <div class="icon-box bg-white p-2 border-round-lg shadow-sm">
                                                <i class="pi pi-wrench text-blue-600"></i>
                                            </div>
                                            <span class="font-bold text-800">Mantenimiento</span>
                                        </div>
                                        <p-tag [value]="maintenanceStatus()" 
                                               [severity]="maintenanceStatus() === 'Al día' ? 'success' : (maintenanceStatus() === 'No programado' ? 'secondary' : 'danger')"></p-tag>
                                    </div>
                                    <div class="text-center py-2">
                                        <div class="text-4xl font-bold mb-1" [class.text-red-600]="daysUntilMaintenance() !== null && daysUntilMaintenance()! <= 7">
                                            {{ daysUntilMaintenance() !== null ? daysUntilMaintenance() : '--' }}
                                        </div>
                                        <div class="text-600 text-sm">Días para el próximo</div>
                                    </div>
                                    <div class="mt-3 border-top-1 surface-border pt-2 text-xs text-500">
                                        Programado: {{ (equipment()?.next_maintenance_date | date:'dd/MM/yyyy') || 'Sin programar' }}
                                    </div>
                                </div>
                            </div>

                            <!-- Calibration Card -->
                            <div class="col-12 md:col-4">
                                <div class="summary-card shadow-1 border-round-xl p-3 h-full flex flex-column justify-content-between"
                                     [ngClass]="{'bg-purple-50': calibrationStatus() === 'Vigente', 'bg-orange-50': calibrationStatus() === 'Vence pronto', 'bg-red-50': calibrationStatus() === 'Vencido'}">
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <div class="flex align-items-center gap-2">
                                            <div class="icon-box bg-white p-2 border-round-lg shadow-sm">
                                                <i class="pi pi-verified text-purple-600"></i>
                                            </div>
                                            <span class="font-bold text-800">Calibración</span>
                                        </div>
                                        <p-tag [value]="calibrationStatus()" 
                                               [severity]="calibrationStatus() === 'Vigente' ? 'success' : 'warn'"></p-tag>
                                    </div>
                                    <div class="text-center py-2">
                                        <div class="text-4xl font-bold mb-1" [class.text-red-600]="daysUntilCalibration() !== null && daysUntilCalibration()! < 0">
                                            {{ daysUntilCalibration() !== null ? daysUntilCalibration() : '--' }}
                                        </div>
                                        <div class="text-600 text-sm">Días de validez restantes</div>
                                    </div>
                                    <div class="mt-3 border-top-1 surface-border pt-2 text-xs text-500">
                                        Vencimiento: {{ equipment()?.next_calibration_date | date:'dd/MM/yyyy' || 'N/A' }}
                                    </div>
                                </div>
                            </div>

                            <!-- Usage Card -->
                            <div class="col-12 md:col-4">
                                <div class="summary-card shadow-1 border-round-xl p-3 h-full flex flex-column justify-content-between bg-green-50">
                                    <div class="flex justify-content-between align-items-center mb-3">
                                        <div class="flex align-items-center gap-2">
                                            <div class="icon-box bg-white p-2 border-round-lg shadow-sm">
                                                <i class="pi pi-play text-green-600"></i>
                                            </div>
                                            <span class="font-bold text-800">Uso (Últ. 30 días)</span>
                                        </div>
                                        <p-tag value="Activo" severity="success"></p-tag>
                                    </div>
                                    <div class="text-center py-2">
                                        <div class="text-4xl font-bold mb-1 text-green-700">
                                            {{ usageStats().totalLast30 }}
                                        </div>
                                        <div class="text-600 text-sm">Registros totales</div>
                                    </div>
                                    <div class="mt-3 border-top-1 surface-border pt-2 text-xs text-500">
                                        Histórico acumulado: {{ usageStats().totalEver }} usos
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Mini Timeline for Recent Status -->
                        <div class="mt-4 p-4 border-round-xl surface-50 border-1 surface-border shadow-sm">
                            <div class="flex align-items-center justify-content-between mb-4">
                                <h4 class="m-0 text-900 font-bold flex align-items-center gap-2">
                                    <i class="pi pi-history text-primary"></i>
                                    Actividad Reciente de Estado
                                </h4>
                                <p-button label="Ver Historial Completo" size="small" [text]="true" (onClick)="activeMainTabIndex.set(4)"></p-button>
                            </div>
                            <div class="flex gap-3 overflow-x-auto pb-2 px-1">
                                <div *ngFor="let entry of statusHistory().slice(0, 3)" class="recent-status-pill p-3 border-round-xl bg-white border-1 surface-border shadow-sm flex flex-column gap-2 min-w-15rem">
                                    <div class="flex align-items-center justify-content-between">
                                        <p-tag [value]="translateStatus(entry.to_status)" 
                                               [severity]="entry.to_status === 'ACTIVE' ? 'success' : 'warn'"
                                               styleClass="text-xs"></p-tag>
                                        <span class="text-400 text-xs">{{ entry.changed_at | date:'dd/MM' }}</span>
                                    </div>
                                    <div class="text-700 font-medium text-sm line-height-2 h-3rem overflow-hidden text-overflow-ellipsis">
                                        {{ entry.reason }}
                                    </div>
                                    <div class="flex align-items-center gap-2 text-xs text-500 mt-auto">
                                        <i class="pi pi-user"></i> {{ entry.changed_by }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabpanel>
                    <!-- MANTENIMIENTOS -->
                    <p-tabpanel [value]="1">
                        <div class="flex justify-content-between align-items-center mb-4">
                            <div>
                                <h3 class="m-0 text-900 font-bold">Historial Técnico</h3>
                                <p class="m-0 text-500 text-sm">Registro de intervenciones preventivas y correctivas</p>
                            </div>
                            <div class="flex align-items-center gap-3">
                                <div class="flex align-items-center gap-2 mr-3">
                                    <p-toggleswitch [ngModel]="showAnnulledMaintenance()" (ngModelChange)="showAnnulledMaintenance.set($event)"></p-toggleswitch>
                                    <span class="text-sm text-600">Ver anulados</span>
                                </div>
                                <p-button label="Nuevo Registro" icon="pi pi-plus"
                                    (onClick)="openEventDrawer('MAINTENANCE')"
                                    styleClass="p-button-raised p-button-warning border-round-lg"></p-button>
                            </div>
                        </div>

                        <p-table [value]="filteredMaintenances()" [paginator]="true" [rows]="10" dataKey="id"
                            responsiveLayout="scroll" styleClass="p-datatable-sm maintenance-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Código</th>
                                    <th>Fecha</th>
                                    <th>Tipo</th>
                                    <th>Descripción</th>
                                    <th>Servicio</th>
                                    <th>Duración</th>
                                    <th style="width: 8rem"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-m>
                                <tr [class.future-event]="m.status === 'SCHEDULLED'" [class.nulled-event]="m.status === 'NULLED'">
                                    <td>
                                        <code class="text-primary font-bold text-sm">{{ m.event_code || '—' }}</code>
                                    </td>
                                    <td class="font-bold text-700">
                                        <i *ngIf="m.parentEventId" class="pi pi-link text-blue-500 mr-2" pTooltip="Continuación de otro evento"></i>
                                        {{ m.event_date | date:'dd/MM/yy' }}
                                        <p-tag *ngIf="m.status === 'NULLED'" value="Anulado" severity="secondary"
                                            styleClass="ml-2 text-xs"></p-tag>
                                        <p-tag *ngIf="m.status === 'SCHEDULLED'" value="Pendiente" severity="info"
                                            styleClass="ml-2 text-xs"></p-tag>
                                    </td>
                                    <td>
                                        <p-tag [value]="translateEventType(m.type)"
                                            [severity]="m.type === 'PREVENTIVE' ? 'success' : 'warning'"
                                            styleClass="px-2"></p-tag>
                                    </td>
                                    <td class="text-600">{{ m.description }}</td>
                                    <td>
                                        <span class="flex align-items-center gap-1"
                                            [ngClass]="m.external_service ? 'text-blue-600' : 'text-600'">
                                            <i
                                                [class]="m.external_service ? 'pi pi-external-link' : 'pi pi-user-edit'"></i>
                                            {{ m.external_service ? (m.supplier?.name || 'Externo') : 'Interno' }}
                                        </span>
                                    </td>
                                    <td class="text-600">
                                        {{ m.duration_hours ? m.duration_hours + ' hs' : '-' }}
                                    </td>
                                    <td>
                                        <div class="flex gap-2">
                                            <p-button icon="pi pi-print"
                                                styleClass="p-button-rounded p-button-text p-button-success p-button-sm"
                                                (onClick)="printEvent('MAINTENANCE', m)" pTooltip="Imprimir Hoja"></p-button>
                                            <p-button icon="pi pi-paperclip"
                                                styleClass="p-button-rounded p-button-text p-button-info p-button-sm"
                                                (onClick)="openEventDrawer('MAINTENANCE', m, 3)" pTooltip="Ver Anexos"></p-button>
                                            <p-button icon="pi pi-pencil"
                                                styleClass="p-button-rounded p-button-text p-button-secondary p-button-sm"
                                                (onClick)="openEventDrawer('MAINTENANCE', m)" [disabled]="m.status === 'NULLED'"></p-button>
                                            <p-button icon="pi pi-ban"
                                                styleClass="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                (onClick)="removeMaintenance(m)" [disabled]="m.status === 'NULLED'"
                                                [loading]="isAnnulling() === m.id"
                                                pTooltip="Anular Registro"></p-button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="7" class="text-center p-5">
                                        <div class="flex flex-column align-items-center gap-2 text-500">
                                            <i class="pi pi-inbox text-4xl"></i>
                                            <span *ngIf="maintenances().length === 0">No hay mantenimientos registrados aún</span>
                                            <div *ngIf="maintenances().length > 0 && filteredMaintenances().length === 0" class="flex flex-column align-items-center gap-1">
                                                <span class="font-medium text-700">No hay mantenimientos activos para mostrar</span>
                                                <span class="text-sm text-500">Hay {{ maintenances().length }} registro(s) anulado(s). Activá la opción <strong>"Ver anulados"</strong> para consultarlos.</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabpanel>

                    <!-- CALIBRACIONES -->
                    <p-tabpanel [value]="2">
                        <div class="flex justify-content-between align-items-center mb-4">
                            <div>
                                <h3 class="m-0 text-900 font-bold">Certificaciones</h3>
                                <p class="m-0 text-500 text-sm">Control de calibración y verificación metrológica</p>
                            </div>
                            <div class="flex align-items-center gap-3">
                                <div class="flex align-items-center gap-2 mr-3">
                                    <p-toggleswitch [ngModel]="showAnnulledCalibration()" (ngModelChange)="showAnnulledCalibration.set($event)"></p-toggleswitch>
                                    <span class="text-sm text-600">Ver anulados</span>
                                </div>
                                <p-button label="Nueva Calibración" icon="pi pi-plus"
                                    (onClick)="openEventDrawer('CALIBRATION')"
                                    styleClass="p-button-raised p-button-info border-round-lg"></p-button>
                            </div>
                        </div>

                        <p-table [value]="filteredCalibrations()" [paginator]="true" [rows]="10" dataKey="id"
                            responsiveLayout="scroll" styleClass="p-datatable-sm calibration-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Código</th>
                                    <th>Fecha</th>
                                    <th>Certificado</th>
                                    <th>Descripción</th>
                                    <th>Estado</th>
                                    <th>Servicio</th>
                                    <th>Duración</th>
                                    <th style="width: 8rem"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-c>
                                <tr [class.future-event]="c.status === 'SCHEDULLED'" [class.nulled-event]="c.status === 'NULLED'">
                                    <td>
                                        <code class="text-primary font-bold text-sm">{{ c.event_code || '—' }}</code>
                                    </td>
                                    <td class="font-bold text-700">
                                        <i *ngIf="c.parentEventId" class="pi pi-link text-blue-500 mr-2" pTooltip="Continuación de otro evento"></i>
                                        {{ c.event_date | date:'dd/MM/yy' }}
                                        <p-tag *ngIf="c.status === 'NULLED'" value="Anulado" severity="secondary"
                                            styleClass="ml-2 text-xs"></p-tag>
                                        <p-tag *ngIf="c.status === 'SCHEDULLED'" value="Pendiente" severity="info"
                                            styleClass="ml-2 text-xs"></p-tag>
                                    </td>
                                    <td>
                                        <div class="flex align-items-center gap-1 text-blue-600 font-medium">
                                            <i class="pi pi-file-o"></i>
                                            {{ c.certificate_number || 'S/N' }}
                                        </div>
                                    </td>
                                    <td class="text-600">{{ c.description }}</td>
                                    <td>
                                        <p-tag *ngIf="c.status === 'NULLED'" severity="secondary" value="Anulado" [rounded]="true"></p-tag>
                                        <ng-container *ngIf="c.status !== 'NULLED'">
                                            <p-tag *ngIf="c.result_approved === true" severity="success" value="Aprobado" [rounded]="true"></p-tag>
                                            <p-tag *ngIf="c.result_approved === false" severity="danger" value="Rechazado" [rounded]="true"></p-tag>
                                            <p-tag *ngIf="c.result_approved === null" severity="warning" value="Programado" [rounded]="true"></p-tag>
                                        </ng-container>
                                    </td>
                                    <td>
                                        <span class="flex align-items-center gap-1"
                                            [ngClass]="c.external_service ? 'text-blue-600' : 'text-600'">
                                            <i
                                                [class]="c.external_service ? 'pi pi-external-link' : 'pi pi-user-edit'"></i>
                                            {{ c.external_service ? (c.supplier?.name || 'Externo') : 'Interno' }}
                                        </span>
                                    </td>
                                    <td class="text-600">
                                        {{ c.duration_hours ? c.duration_hours + ' hs' : '-' }}
                                    </td>
                                    <td>
                                        <div class="flex gap-2">
                                            <p-button icon="pi pi-print"
                                                styleClass="p-button-rounded p-button-text p-button-success p-button-sm"
                                                (onClick)="printEvent('CALIBRATION', c)" pTooltip="Imprimir Hoja"></p-button>
                                            <p-button icon="pi pi-paperclip"
                                                styleClass="p-button-rounded p-button-text p-button-info p-button-sm"
                                                (onClick)="openEventDrawer('CALIBRATION', c, 3)" pTooltip="Ver Anexos"></p-button>
                                            <p-button icon="pi pi-pencil"
                                                styleClass="p-button-rounded p-button-text p-button-secondary p-button-sm"
                                                (onClick)="openEventDrawer('CALIBRATION', c)" [disabled]="c.status === 'NULLED'"></p-button>
                                            <p-button icon="pi pi-ban"
                                                styleClass="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                (onClick)="removeCalibration(c)" [disabled]="c.status === 'NULLED'"
                                                [loading]="isAnnulling() === c.id"
                                                pTooltip="Anular Registro"></p-button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>

                            <ng-template pTemplate="emptymessage">
                                <tr *ngIf="filteredCalibrations().length === 0">
                                    <td colspan="8" class="text-center p-5">
                                        <div class="flex flex-column align-items-center gap-2 text-500">
                                            <i class="pi pi-verified text-4xl"></i>
                                            <span *ngIf="calibrations().length === 0">No hay calibraciones registradas aún</span>
                                            <div *ngIf="calibrations().length > 0 && filteredCalibrations().length === 0" class="flex flex-column align-items-center gap-1">
                                                <span class="font-medium text-700">No hay calibraciones activas para mostrar</span>
                                                <span class="text-sm text-500">Hay {{ calibrations().length }} registro(s) anulado(s). Activá la opción <strong>"Ver anulados"</strong> para consultarlos.</span>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabpanel>

                    <!-- USOS -->
                    <p-tabpanel [value]="3">
                        <div class="flex justify-content-between align-items-center mb-4">
                            <div>
                                <h3 class="m-0 text-900 font-bold">Registro de Uso</h3>
                                <p class="m-0 text-500 text-sm">Trazabilidad de operadores y tareas realizadas</p>
                            </div>
                            <div class="flex align-items-center gap-3">
                                <div class="flex align-items-center gap-2 mr-3">
                                    <p-toggleswitch [ngModel]="showAnnulledUsage()" (ngModelChange)="showAnnulledUsage.set($event)"></p-toggleswitch>
                                    <span class="text-sm text-600">Ver anulados</span>
                                </div>
                                <p-button label="Nuevo Uso" icon="pi pi-plus" (onClick)="openNewUsage()"
                                    [disabled]="equipment()?.status === 'OUT_OF_SERVICE' || !!activeUsage()"
                                    [pTooltip]="equipment()?.status === 'OUT_OF_SERVICE' ? 'No se puede registrar uso de un equipo fuera de servicio' : (activeUsage() ? 'Ya existe un uso en curso que debe finalizarse primero' : '')"
                                    tooltipPosition="left"
                                    styleClass="p-button-raised p-button-success border-round-lg"></p-button>
                            </div>
                        </div>

                        <!-- Active Usage Banner -->
                        <div *ngIf="activeUsage()" class="p-3 border-round-lg bg-green-50 border-1 border-green-200 mb-4 flex align-items-center justify-content-between">
                           <div class="flex align-items-center gap-3">
                               <div class="w-3rem h-3rem border-round-circle bg-green-100 flex align-items-center justify-content-center text-green-700">
                                   <i class="pi pi-play-circle text-2xl"></i>
                               </div>
                               <div>
                                   <div class="text-green-900 font-bold">Equipo actualmente en uso</div>
                                   <div class="text-green-700 text-sm">Iniciado por <b>{{ activeUsage().user_id }}</b> a las {{ activeUsage().start_date | date:'shortTime' }}</div>
                               </div>
                           </div>
                           <p-button label="Finalizar Uso" icon="pi pi-stop-circle" severity="success" [rounded]="true" (onClick)="quickFinishUsage(activeUsage())"></p-button>
                        </div>

                        <p-table [value]="filteredUsages()" [paginator]="true" [rows]="10" responsiveLayout="scroll"
                            styleClass="p-datatable-sm usage-table">
                            <ng-template pTemplate="header">
                                <tr>
                                    <th>Inicio</th>
                                    <th>Fin</th>
                                    <th>Responsable</th>
                                    <th>Tarea</th>
                                    <th style="width: 50px"></th>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-u>
                                <tr [class.nulled-event]="u.is_annulled">
                                    <td class="font-bold text-700">{{ u.start_date | date:'shortTime' }} <small
                                            class="text-500 block text-xs">{{ u.start_date | date:'dd/MM' }}</small>
                                    </td>
                                    <td class="text-600">
                                        <p-tag *ngIf="u.is_annulled" value="Anulado" severity="secondary"
                                            styleClass="px-2 text-xs"></p-tag>
                                        <ng-container *ngIf="!u.is_annulled">
                                            <ng-container *ngIf="u.end_date">
                                                {{ u.end_date | date:'shortTime' }}
                                                <small class="text-500 block text-xs">{{ u.end_date | date:'dd/MM' }}</small>
                                            </ng-container>
                                            <p-tag *ngIf="!u.end_date" value="En curso" severity="success"
                                                styleClass="px-2 text-xs"></p-tag>
                                        </ng-container>
                                    </td>
                                    <td class="text-700 font-medium">{{ u.user_id }}</td>
                                    <td class="text-600">{{ u.purpose }}</td>
                                    <td>
                                        <div class="flex gap-2">
                                            <p-button *ngIf="!u.end_date" icon="pi pi-stop"
                                                styleClass="p-button-rounded p-button-text p-button-success p-button-sm"
                                                (onClick)="quickFinishUsage(u)" pTooltip="Finalizar Uso"></p-button>
                                            <p-button icon="pi pi-paperclip"
                                                styleClass="p-button-rounded p-button-text p-button-info p-button-sm"
                                                (onClick)="editUsage(u, 1)" pTooltip="Ver Anexos"></p-button>
                                            <p-button icon="pi pi-pencil"
                                                styleClass="p-button-rounded p-button-text p-button-secondary p-button-sm"
                                                (onClick)="editUsage(u)" [disabled]="u.is_annulled"></p-button>
                                            <p-button icon="pi pi-ban"
                                                styleClass="p-button-rounded p-button-text p-button-danger p-button-sm"
                                                (onClick)="removeUsage(u)" [disabled]="u.is_annulled"
                                                [loading]="isAnnulling() === u.id"
                                                pTooltip="Anular Registro"></p-button>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                            <ng-template pTemplate="emptymessage">
                                <tr>
                                    <td colspan="5" class="text-center p-5">
                                        <div class="flex flex-column align-items-center gap-2 text-500">
                                            <i class="pi pi-calendar-plus text-4xl"></i>
                                            <span>No hay registros de uso aún</span>
                                        </div>
                                    </td>
                                </tr>
                            </ng-template>
                        </p-table>
                    </p-tabpanel>

                    <p-tabpanel [value]="4">
                        <div class="flex justify-content-between align-items-center mb-4">
                            <div>
                                <h3 class="m-0 text-900 font-bold">Historial de Estado del Equipo</h3>
                                <p class="m-0 text-500 text-sm">Trazabilidad completa de cambios de estado</p>
                            </div>
                            <span
                                class="px-3 py-1 bg-indigo-100 text-indigo-700 border-round-lg text-xs font-bold border-1 border-indigo-200">
                                <i class="pi pi-verified mr-1"></i> {{ statusHistory().length }} registro(s)
                            </span>
                        </div>

                        <div *ngIf="statusHistory().length === 0"
                            class="flex flex-column align-items-center gap-2 text-500 py-6">
                            <i class="pi pi-list text-4xl"></i>
                            <span>No hay registros de cambio de estado aún</span>
                        </div>

                        <div class="timeline-status-list" *ngIf="statusHistory().length > 0">
                            <div *ngFor="let entry of statusHistory(); let i = index; let last = last"
                                class="timeline-status-entry" [class.last-entry]="last">
                                <div class="timeline-dot" [ngClass]="{
                                    'dot-active': entry.to_status === 'ACTIVE',
                                    'dot-maintenance': entry.to_status === 'MAINTENANCE',
                                    'dot-out': entry.to_status === 'OUT_OF_SERVICE',
                                    'dot-withdrawn': entry.to_status === 'WITHDRAWN'
                                }"></div>
                                <div
                                    class="timeline-content border-round-lg p-3 mb-2 surface-50 border-1 surface-border">
                                    <div class="flex align-items-center gap-2 flex-wrap mb-1">
                                        <p-tag *ngIf="entry.from_status" [value]="translateStatus(entry.from_status)"
                                            severity="secondary" styleClass="text-xs"></p-tag>
                                        <i *ngIf="entry.from_status" class="pi pi-arrow-right text-xs text-400"></i>
                                        <p-tag [value]="translateStatus(entry.to_status)"
                                            [severity]="entry.to_status === 'ACTIVE' ? 'success' : entry.to_status === 'MAINTENANCE' ? 'warn' : 'danger'"
                                            styleClass="text-xs font-bold"></p-tag>
                                        <span class="text-400 text-xs ml-auto">
                                            <i class="pi pi-clock mr-1"></i>{{ entry.changed_at | date:'dd/MM/yyyy
                                            HH:mm' }}
                                        </span>
                                    </div>
                                    <div class="text-700 text-sm font-medium">{{ entry.reason }}</div>
                                    <div class="text-xs text-400 mt-1"><i class="pi pi-user mr-1"></i>{{
                                        entry.changed_by }}</div>
                                </div>
                            </div>
                        </div>
                    </p-tabpanel>

                    <!-- DOCUMENTACIÓN (NEW) -->
                    <p-tabpanel [value]="5">
                        <div class="p-3">
                            <app-file-attachments *ngIf="equipmentId()" [referenceId]="equipmentId()!" folder="PROTOCOL"
                                title="Manuales y Guías del Equipo">
                            </app-file-attachments>
                        </div>
                    </p-tabpanel>

                    <!-- PREDICCIONES Y SALUD -->
                    <p-tabpanel [value]="6">
                        <div class="grid p-3">
                            <div class="col-12 md:col-5 lg:col-4">
                                <div class="premium-card surface-card border-round-xl p-4 shadow-1 h-full flex flex-column align-items-center justify-content-center"
                                     [ngClass]="{'bg-green-50 border-green-200 border-1': predictiveScore()?.risk_level === 'LOW',
                                                 'bg-yellow-50 border-yellow-200 border-1': predictiveScore()?.risk_level === 'MEDIUM',
                                                 'bg-red-50 border-red-200 border-1': predictiveScore()?.risk_level === 'HIGH'}">
                                    <h3 class="m-0 mb-4 text-center w-full font-bold text-700 flex align-items-center justify-content-center gap-2">
                                        Health Score Predictivo
                                        <i class="pi pi-info-circle text-500 text-lg cursor-pointer hover:text-primary transition-colors transition-duration-200" 
                                           (click)="opHealth.toggle($event)"></i>
                                    </h3>
                                    
                                    <p-overlayPanel #opHealth [style]="{width: '320px'}">
                                        <div class="p-2">
                                            <h4 class="mt-0 mb-2 font-bold text-700 border-bottom-1 surface-border pb-2">Lógica del Score</h4>
                                            <p class="text-sm text-700 m-0 mb-2 line-height-3">
                                                El <b>Health Score (0-100)</b> evalúa la condición del equipo analizando 4 factores basados en un <b>período móvil de los últimos 24 meses</b>:
                                            </p>
                                            <ul class="text-sm text-600 pl-3 m-0 flex flex-column gap-2 line-height-3">
                                                <li><b>Tendencia del MTBM</b> (Tiempo entre mantenimientos)</li>
                                                <li>Frecuencia de <b>Mantenimientos Correctivos</b> (Fallas)</li>
                                                <li><b>Disponibilidad Histórica</b> (Downtime vs Uptime)</li>
                                                <li><b>Vencimientos</b> preventivos cercanos</li>
                                            </ul>
                                        </div>
                                    </p-overlayPanel>

                                    <div class="flex flex-column align-items-center justify-content-center my-3" *ngIf="predictiveScore()">
                                        <p-knob [ngModel]="predictiveScore()?.score || 0" 
                                                [readonly]="true" 
                                                [size]="160"
                                                [strokeWidth]="10"
                                                [valueColor]="predictiveScore()?.risk_level === 'LOW' ? '#22c55e' : (predictiveScore()?.risk_level === 'MEDIUM' ? '#eab308' : '#ef4444')">
                                        </p-knob>
                                        <div class="text-sm font-bold mt-3 uppercase tracking-wide" [ngClass]="{'text-green-600': predictiveScore()?.risk_level === 'LOW', 'text-yellow-600': predictiveScore()?.risk_level === 'MEDIUM', 'text-red-600': predictiveScore()?.risk_level === 'HIGH'}">
                                            Riesgo {{ predictiveScore()?.risk_level === 'LOW' ? 'Bajo' : (predictiveScore()?.risk_level === 'MEDIUM' ? 'Medio' : 'Alto') }}
                                        </div>
                                    </div>
                                    <div class="flex flex-column align-items-center justify-content-center my-5 text-500" *ngIf="!predictiveScore()">
                                        <i class="pi pi-chart-pie text-4xl mb-2"></i>
                                        <span class="font-medium">Sin datos predictivos</span>
                                    </div>
                                    
                                    <!-- Rules triggered -->
                                    <div class="mt-4 w-full" *ngIf="predictiveScore()?.rules_triggered?.length > 0">
                                        <div class="text-sm font-bold text-600 mb-2">Factores de Riesgo / Penalización:</div>
                                        <div class="flex flex-column gap-2">
                                            <div *ngFor="let rule of predictiveScore()?.rules_triggered" class="flex align-items-start gap-2 bg-white-alpha-50 p-2 border-round text-sm">
                                                <i class="pi pi-exclamation-circle text-orange-500 mt-1"></i>
                                                <span class="text-700">{{ rule }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-4 w-full text-center" *ngIf="predictiveScore() && !predictiveScore()?.rules_triggered?.length">
                                        <p-tag severity="success" value="Equipo en óptimas condiciones" icon="pi pi-check-circle"></p-tag>
                                    </div>
                                    
                                    <!-- Criteria Text Always Visible -->
                                    <div class="mt-4 pt-3 border-top-1 surface-border w-full text-center text-xs">
                                        <p class="text-600 m-0 mb-2">Calculado (últimos 24 meses) penalizando por:</p>
                                        <div class="flex flex-wrap justify-content-center gap-2 text-500">
                                            <span class="bg-gray-100 px-2 py-1 border-round">Freq. Correctiva</span>
                                            <span class="bg-gray-100 px-2 py-1 border-round">Tendencia MTBM</span>
                                            <span class="bg-gray-100 px-2 py-1 border-round">Alta Inactividad</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-12 md:col-7 lg:col-8">
                                <div class="grid">
                                    <!-- MTBM -->
                                    <div class="col-12 md:col-6">
                                        <div class="summary-card shadow-1 border-round-xl p-4 surface-card flex flex-column justify-content-between h-full">
                                            <div class="flex justify-content-between align-items-center mb-3">
                                                <div class="flex align-items-center gap-2">
                                                    <div class="icon-box bg-blue-50 p-2 border-round-lg">
                                                        <i class="pi pi-clock text-blue-600 text-xl"></i>
                                                    </div>
                                                    <span class="font-bold text-700">MTBM (Entre Mantenimientos)</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-4xl font-bold mb-1 text-800">
                                                    {{ (analyticsData()?.mtbm_days | number:'1.0-1') || '--' }} <span class="text-lg text-500 font-normal">días</span>
                                                </div>
                                                <div class="text-500 text-sm">Promedio Histórico (Últimos 24 meses)</div>
                                            </div>
                                            <div class="mt-3 border-top-1 surface-border pt-3 text-sm flex align-items-center gap-2">
                                                <span class="text-600">Tendencia reciente (últimos 3):</span>
                                                <span class="font-bold" [ngClass]="(analyticsData()?.gap_trend || 1) < 0.8 ? 'text-red-500' : 'text-green-500'">
                                                    {{ (analyticsData()?.mtbm_recent_days | number:'1.0-1') || '--' }} días
                                                    <i class="pi" [ngClass]="(analyticsData()?.gap_trend || 1) < 0.8 ? 'pi-arrow-down' : 'pi-arrow-right'"></i>
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- Downtime -->
                                    <div class="col-12 md:col-6">
                                        <div class="summary-card shadow-1 border-round-xl p-4 surface-card flex flex-column justify-content-between h-full">
                                            <div class="flex justify-content-between align-items-center mb-3">
                                                <div class="flex align-items-center gap-2">
                                                    <div class="icon-box bg-red-50 p-2 border-round-lg">
                                                        <i class="pi pi-exclamation-triangle text-red-600 text-xl"></i>
                                                    </div>
                                                    <span class="font-bold text-700">Tiempo Inactivo</span>
                                                </div>
                                            </div>
                                            <div>
                                                <div class="text-4xl font-bold mb-1 text-800">
                                                    <ng-container *ngIf="analyticsData()?.downtime_minutes >= 1440; else hoursFormat">
                                                        {{ (analyticsData()?.downtime_minutes / 1440).toFixed(1) }} <span class="text-lg text-500 font-normal">días</span>
                                                    </ng-container>
                                                    <ng-template #hoursFormat>
                                                        <ng-container *ngIf="analyticsData()?.downtime_minutes >= 60; else minFormat">
                                                            {{ (analyticsData()?.downtime_minutes / 60).toFixed(1) }} <span class="text-lg text-500 font-normal">hs</span>
                                                        </ng-container>
                                                        <ng-template #minFormat>
                                                            {{ analyticsData()?.downtime_minutes || 0 }} <span class="text-lg text-500 font-normal">min</span>
                                                        </ng-template>
                                                    </ng-template>
                                                </div>
                                                <div class="text-500 text-sm">Downtime Acumulado Total (Histórico)</div>
                                            </div>
                                            <div class="mt-3 border-top-1 surface-border pt-3 text-sm">
                                                Calculado en base al tiempo que pasó fuera de servicio o en mantenimiento.
                                            </div>
                                        </div>
                                    </div>

                                    <!-- Total Cost -->
                                    <div class="col-12">
                                        <div class="summary-card shadow-1 border-round-xl p-4 surface-card flex align-items-start gap-4">
                                            <div class="icon-box bg-green-50 p-3 border-round-lg mt-1">
                                                <i class="pi pi-dollar text-green-600 text-2xl"></i>
                                            </div>
                                            <div class="flex-1">
                                                <div class="text-500 text-sm mb-2">Costo total histórico invertido en mantenimientos y calibraciones</div>
                                                
                                                <div *ngIf="!analyticsData()?.costs_by_currency?.length" class="text-3xl font-bold text-800">$0.00</div>
                                                
                                                <div class="flex flex-column gap-2">
                                                    <div *ngFor="let cost of analyticsData()?.costs_by_currency" class="flex align-items-center gap-2">
                                                        <span class="text-3xl font-bold text-800">{{ cost.amount | number:'1.2-2' }}</span>
                                                        <span class="text-xl font-medium text-600">{{ cost.currency }}</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </p-tabpanel>

                </p-tabpanels>
                </p-tabs>
            </div>
        </div>
    </div>
</div>

<!-- Loader Template -->
<ng-template #skeleton>
    <div class="flex justify-content-center align-items-center" style="height: 50vh;">
        <i class="pi pi-spin pi-spinner text-6xl text-primary"></i>
    </div>
</ng-template>


<!-- ==============================================
     DRAWER: EVENTO (MANTENIMIENTO / CALIBRACIÓN)
     ============================================== -->
<app-equipment-event-drawer
    [(visible)]="showEventDrawer"
    [eventType]="currentEventType"
    [equipmentId]="equipmentId()"
    [equipment]="equipment()"
    [inventoryItems]="inventoryItems()"
    [vendors]="vendors()"
    [recentEvents]="recentEvents()"
    [internalConsumablesMap]="internalConsumablesMap"
    [editData]="eventEditData"
    [initialTabIndex]="eventInitialTabIndex"
    [eventMode]="eventMode"
    (onSaved)="onEventSaved()">
</app-equipment-event-drawer>

<!-- ==============================================
     DRAWER: USO (REFACTORED)
     ============================================== -->
<p-drawer #usageDrawer [(visible)]="showUsageModal" position="right" styleClass="p-drawer-xl" [modal]="true"
    [dismissible]="true" id="usage-drawer">
    <ng-template pTemplate="header">
        <div class="drawer-header w-full border-round-top-xl" [ngClass]="isEditingUsage() ? 'bg-primary-light' : 'bg-usage-light'">
            <h2 class="drawer-title" [ngClass]="isEditingUsage() ? 'text-primary' : 'text-usage'">
                <i class="pi" [ngClass]="isEditingUsage() ? 'pi-pencil' : 'pi-history'"></i>
                {{ isEditingUsage() ? 'Editar Uso' : 'Registrar Uso' }}
            </h2>
            <span class="drawer-subtitle">{{ isEditingUsage() ? 'Modificando registro de bitácora' : 'Bitácora de operación diaria' }}</span>
        </div>
    </ng-template>

    <div class="drawer-content-scroll">
        <form [formGroup]="usageForm" class="p-fluid">
            <p-tabs [value]="usageTabIndex()" (valueChange)="usageTabIndex.set($event)" styleClass="main-drawer-tabs">
                <p-tablist>
                    <p-tab [value]="0"><i class="pi pi-info-circle mr-2"></i>General</p-tab>
                    <p-tab [value]="1"><i class="pi pi-paperclip mr-2"></i>Anexos</p-tab>
                </p-tablist>
                <p-tabpanels>
                    <p-tabpanel [value]="0">
                    <div class="grid mt-3">
                        <div class="field col-12 md:col-6">
                            <p-floatlabel>
                                <p-datepicker inputId="u_start" formControlName="start_date" [showTime]="true"
                                    class="w-full" appendTo="body"></p-datepicker>
                                <label for="u_start">Inicio de Operación</label>
                            </p-floatlabel>
                        </div>

                        <div class="field col-12 md:col-6">
                            <p-floatlabel>
                                <p-datepicker inputId="u_end" formControlName="end_date" [showTime]="true"
                                    class="w-full" appendTo="body" [showClear]="true"></p-datepicker>
                                <label for="u_end">Fin de Operación (opcional)</label>
                            </p-floatlabel>
                        </div>

                        <div class="field col-12 mt-3">
                            <p-floatlabel>
                                <p-select id="u_user" [options]="users()" formControlName="user_id"
                                    optionLabel="fullName" optionValue="user" [filter]="true" class="w-full"
                                    appendTo="body"></p-select>
                                <label for="u_user">Operador Responsable</label>
                            </p-floatlabel>
                        </div>

                        <div class="field col-12 mt-3">
                            <p-floatlabel>
                                <p-autocomplete id="u_purp" [suggestions]="filteredUsagePurposes()" 
                                    (completeMethod)="searchUsagePurposes($event)" 
                                    formControlName="purpose" 
                                    [dropdown]="true" 
                                    field="name"
                                    styleClass="w-full"
                                    [inputStyle]="{width: '100%'}"
                                    appendTo="body">
                                </p-autocomplete>
                                <label for="u_purp">Propósito del Uso</label>
                            </p-floatlabel>
                            <small class="text-500 block mt-1">Seleccione una opción preconfigurada o escriba una nueva.</small>
                        </div>

                        <div class="field col-12 mt-3">
                            <p-floatlabel>
                                <textarea id="u_notes" pInputTextarea rows="4" formControlName="notes"
                                    class="w-full"></textarea>
                                <label for="u_notes">Observaciones / Incidencias</label>
                            </p-floatlabel>
                        </div>
                    </div>
                </p-tabpanel>

                <p-tabpanel [value]="1">
                    <div class="mt-2" *ngIf="(usageForm.get('id')?.value || currentUsageId()); else newUsageMsg">
                        <app-file-attachments [referenceId]="usageForm.get('id')?.value || currentUsageId()!" folder="EVIDENCE"
                            title="Evidencia de Uso">
                        </app-file-attachments>
                    </div>
                    <ng-template #newUsageMsg>
                        <div
                            class="flex flex-column align-items-center gap-2 py-5 text-500 bg-gray-50 border-round-lg border-1 surface-border">
                            <i class="pi pi-info-circle text-2xl"></i>
                            <span class="text-center px-4">Primero debe registrar el uso para poder adjuntar archivos de
                                evidencia.</span>
                        </div>
                    </ng-template>
                </p-tabpanel>
            </p-tabpanels>
            </p-tabs>
        </form>
    </div>

    <div class="drawer-footer">
        <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary"
            (onClick)="showUsageModal.set(false)"></p-button>
        <p-button [label]="isEditingUsage() ? 'Guardar Cambios' : 'Registrar Entrada'" 
            [icon]="isEditingUsage() ? 'pi pi-save' : 'pi pi-check'" 
            severity="success" styleClass="border-round-lg shadow-2"
            (onClick)="saveUsage()" [disabled]="usageForm.invalid || loading()" [loading]="loading()"></p-button>
    </div>
</p-drawer>

<!-- Equipment Edit Modal -->
<app-equipment-form [visible]="showEditModal()" [item]="equipmentFormValue()" [loading]="loading()"
    (visibleChange)="showEditModal.set($event)" (onSave)="saveEquipment($event)">
</app-equipment-form>

<!-- Status Edit Modal (ISO 17025) -->
<p-dialog header="Cambiar Estado del Equipo" [(visible)]="showStatusModal" [modal]="true" [style]="{width: '450px'}"
    [draggable]="false" [resizable]="false">
    <form [formGroup]="statusForm" class="p-fluid mt-3">
        <div class="field mb-4">
            <label for="status" class="block font-bold mb-2">Nuevo Estado <span class="text-red-500">*</span></label>
            <p-select id="status" [options]="[
                { label: 'Activo/Operativo', id: 'ACTIVE' },
                { label: 'Fuera de Servicio', id: 'OUT_OF_SERVICE' },
                { label: 'En Mantenimiento', id: 'MAINTENANCE' },
                { label: 'Retirado', id: 'WITHDRAWN' }
            ]" formControlName="status" optionLabel="label" optionValue="id" appendTo="body" class="w-full"></p-select>
        </div>
        <div class="field">
            <label for="reason" class="block font-bold mb-2">Razón del Cambio <span
                    class="text-red-500">*</span></label>
            <textarea id="reason" pInputTextarea formControlName="status_change_reason" rows="3" class="w-full"
                placeholder="Ej: Falla en calibración mensual..."></textarea>
            <small class="text-500 mt-1 block"><i class="pi pi-info-circle mr-1"></i>Requerido para mantener la
                trazabilidad del equipo.</small>
        </div>
        <small *ngIf="statusForm.value.status === equipment()?.status" class="text-red-500 mt-2 block font-bold">
            <i class="pi pi-exclamation-triangle mr-1"></i>El equipo ya se encuentra en este estado.
        </small>
    </form>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" icon="pi pi-times" [text]="true" severity="secondary"
            (onClick)="showStatusModal.set(false)"></p-button>
        <p-button label="Guardar Cambio" icon="pi pi-check" severity="warn" (onClick)="saveStatus()"
            [disabled]="statusForm.invalid || statusForm.value.status === equipment()?.status" [loading]="loading()"></p-button>
    </ng-template>
</p-dialog>